import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var WStandardButton = /*#__PURE__*/function (_Vue) {
  function WStandardButton() {
    var _this;
    _classCallCheck(this, WStandardButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WStandardButton, [].concat(args));
    _defineProperty(_this, "label", void 0);
    _defineProperty(_this, "type", void 0);
    _defineProperty(_this, "size", void 0);
    _defineProperty(_this, "isLoading", void 0);
    _defineProperty(_this, "minHeight", void 0);
    _defineProperty(_this, "minWidth", void 0);
    _defineProperty(_this, "disabled", void 0);
    return _this;
  }
  _inherits(WStandardButton, _Vue);
  return _createClass(WStandardButton);
}(Vue);
export { WStandardButton as default };
__decorate([Prop({
  default: ''
})], WStandardButton.prototype, "label", void 0);
__decorate([Prop({
  default: 'primary'
})], WStandardButton.prototype, "type", void 0);
__decorate([Prop({
  default: 'default'
})], WStandardButton.prototype, "size", void 0);
__decorate([Prop({
  default: false
})], WStandardButton.prototype, "isLoading", void 0);
__decorate([Prop({
  default: '32px'
})], WStandardButton.prototype, "minHeight", void 0);
__decorate([Prop()], WStandardButton.prototype, "minWidth", void 0);
__decorate([Prop({
  default: false
})], WStandardButton.prototype, "disabled", void 0);